module.exports = __webpack_public_path__ + "img/rateBack.395b728f.png";